<!--  -->
<template>
  <div class="container">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="searchBox">
      <div style="margin-bottom: 10px;display: flex;">
        <!-- statusView=='S'&& headerData.status==1-->
        <div v-if="isCanAudit">
          <el-button v-if="statusView=='S'&& headerData.status==1||statusView=='C'&& headerData.status==2||isBool=='gather'||statusView=='O'&& (headerData.status==3||headerData.status==4)||isBool=='gather'||isRouter=='qspiToDo'&&statusView=='OC'&&(headerData.status==2||headerData.status==3)||isBool=='All'" size="mini" class="btn" type="primary" @click="saveData">保存</el-button>
          <el-button v-if="statusView=='S'&& headerData.status==1||statusView=='C'&& (headerData.status==2||headerData.status==3)||isBool=='grade'||isRouter=='qspiToDo'&&statusView=='OC'&&(headerData.status==2||headerData.status==3)||isBool=='All'" size="mini" class="btn" type="primary" @click="submitData">提交</el-button>
        </div>
        <el-button size="mini" class="btn" type="primary" @click="changeShow">{{isShow?'隐藏评分标准':'查看评分标准'}}</el-button>
      </div>

      <el-card class="box-card">
        <el-form ref="form" :model="form" :inline="true" label-width="80px">
          <el-form-item label="评价期">
            <el-input v-model="headerData.appraisePeriod" disabled></el-input>
          </el-form-item>
          <el-form-item label="Facility 编号">
            <el-input v-model="headerData.facilityCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="Facility 名称">
            <el-input v-model="headerData.facilityName" disabled></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-input v-model="headerData.statusView" disabled></el-input>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-input v-model="headerData.closingDate" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
      <el-table :span-method="arraySpanMethod" :header-cell-style="setHeaderStyle" class="setTable" :cell-class-name="cell" ref="table" :data="ruleForm.tableData" @selection-change="selectionChange" :row-class-name="tableRowClassName" max-height="700" highlight-current-row>
        <el-table-column align="center" :label="temName" width="400" fixed>
          <el-table-column prop="name" label="Criteria" align="center" width="200" show-overflow-tooltip fixed></el-table-column>
          <el-table-column prop="description" label="Description" align="center" width="200" show-overflow-tooltip fixed></el-table-column>
        </el-table-column>

        <el-table-column v-if="isShow" label="评分描述" align="center" width="400">
          <el-table-column v-if="isShow" prop="standard1" label="System Benchmark" align="center" width="200"></el-table-column>
          <el-table-column v-if="isShow" prop="standard2" label="Excellent" align="center" width="200"></el-table-column>
          <el-table-column v-if="isShow" prop="standard3" label="Self Managed" align="center" width="200"></el-table-column>
          <el-table-column v-if="isShow" prop="standard4" label="Baseline" align="center" width="200"></el-table-column>
          <el-table-column v-if="isShow" prop="standard5" label="Needs Improvement" align="center" width="200"></el-table-column>
        </el-table-column>
        <el-table-column label="权重" align="center" width="80">
          <el-table-column prop="wt1View" label="Wt." align="center" width="80"></el-table-column>
        </el-table-column>

        <el-table-column :label="currentAppraisePeriod" align="center">
          <el-table-column label="供应商自评" align="center">
            <el-table-column prop="currentSupplierScore" label="Score" align="center" width="80">
              <template slot="header">
                <span>Score</span>
                <span class="star">*</span>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.parentId" :class="statusView!='S'?'setTop':''">
                  <el-form-item v-if="statusView=='S'&& headerData.status==1&&scope.$index!=ruleForm.tableData.length-1&&scope.$index!=ruleForm.tableData.length-2" :prop="'tableData.' + scope.$index + '.currentSupplierScore'" :rules="statusView=='S'&&scope.row.parentId?rules.currentSupplierScore:''">
                    <el-input v-model="scope.row.currentSupplierScore" class="stretchNone" :rows="1" type="textarea" :disabled="scope.row.parentId?false:true" @blur="setSup(scope.row)" @input="scope.row.currentSupplierScore=scope.row.currentSupplierScore.replace(/[^-0-9]/g,'')"></el-input>
                  </el-form-item>
                  <span v-else>{{scope.row.currentSupplierScore}}</span>
                </div>
                <span v-else>{{scope.row.currentSupplierScore}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="currentSupplierWtScore" label="Wt. Score" width="80" align="center">
              <template slot-scope="scope">
                <span style="width:100%;display: inline-block;height:32px;display: flex;justify-content: center;align-items: center;">{{scope.row.currentSupplierWtScore}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="currentSupplierFacts" label="Facts" width="300" align="center">
              <template slot="header">
                <span>Facts</span>
                <span class="star">*</span>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.parentId">
                  <el-form-item v-if="statusView=='S'&&  headerData.status==1&&scope.$index!=ruleForm.tableData.length-1&&scope.$index!=ruleForm.tableData.length-2" :prop="'tableData.' + scope.$index + '.currentSupplierFacts'" :rules="statusView=='S'&&scope.row.parentId?rules.currentSupplierFacts:''">
                    <el-input class="stretchNone" :disabled="scope.row.parentId?false:true" type="textarea" maxlength="1000" :autosize="{ minRows: 4, maxRows: 4}" :rows="4" placeholder="" v-model="scope.row.currentSupplierFacts" style="width:100%;margin-top:15px;">
                    </el-input>
                    <i @click.stop="openDialog(scope.row,scope.$index,'supplier')" style="position:absolute;right:10px;bottom:10%" class="el-icon-edit-outline"></i>
                  </el-form-item>
                  <el-tooltip v-else class="item" effect="dark" :content="scope.row.currentSupplierFacts" placement="top-start">
                    <span style="width:100%;display: inline-block;maxHeight: 130px;padding:20px 0px;box-sizing: border-box;">{{scope.row.currentSupplierFacts}}</span>
                  </el-tooltip>
                </div>
                <el-tooltip v-else class="item" effect="dark" :content="scope.row.currentSupplierFacts" placement="top-start">
                  <span style="width:100%;display: inline-block;maxHeight: 130px;padding:20px 0px;box-sizing: border-box;">{{scope.row.currentSupplierFacts}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="Final" v-if="statusView=='C'||statusView=='O'||statusView=='OC'||statusView=='S'&&(headerData.status==5||headerData.status==6||headerData.status==7)" align="center">
            <el-table-column prop="currentFinalScore" label="Score" align="center" width="80" v-if="statusView=='C'||statusView=='O'||statusView=='OC'||statusView=='S'&&(headerData.status==5||headerData.status==6||headerData.status==7)">
              <template slot="header">
                <span>Score</span>
                <span class="star">*</span>
              </template>
              <template slot-scope="scope">
                <div v-if="isCanAudit" :class="statusView!='S'?'setTop':''">
                  <el-form-item v-if="(statusView=='C'&& (headerData.status==2||headerData.status==3)||statusView=='O'&& (headerData.status==3||headerData.status==4)||statusView=='OC'&&(headerData.status==2||headerData.status==3||headerData.status==4))&&scope.$index!=ruleForm.tableData.length-1&&scope.$index!=ruleForm.tableData.length-2&&scope.row.parentId" :prop="'tableData.' + scope.$index + '.currentFinalScore'" :rules="scope.row.parentId&&(statusView=='C'||statusView=='O'||statusView=='OC')?rules.currentFinalScore:''">
                    <el-input :disabled="scope.row.parentId?false:true" @blur="setCurrent(scope.row)" @input="scope.row.currentFinalScore=scope.row.currentFinalScore.replace(/[^-0-9]/g,'')" v-model="scope.row.currentFinalScore"></el-input>
                  </el-form-item>
                  <span v-else>{{scope.row.currentFinalScore}}</span>
                </div>
                <span v-else>{{scope.row.currentFinalScore}}</span>

              </template>
            </el-table-column>
            <el-table-column prop="currentFinalWtScore" label="Wt. Score" width="80" align="center" v-if="statusView=='C'||statusView=='O'||statusView=='OC'||statusView=='S'&&(headerData.status==5||headerData.status==6||headerData.status==7)">
              <template slot-scope="scope">
                <span style="display: inline-block;height:32px;display: flex;justify-content: center;align-items: center;">{{scope.row.currentFinalWtScore}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="currentFinalFacts" label="Facts" width="300" align="center" v-if="statusView=='C'||statusView=='O'||statusView=='OC'">
              <template slot="header">
                <span>Facts</span>
                <!-- <span class="star">*</span> -->
              </template>
              <template slot-scope="scope">
                <div v-if="isCanAudit">
                  <div v-if="scope.row.parentId">
                    <div v-if="statusView=='C'&& (headerData.status==2||headerData.status==3)||statusView=='O'&& (headerData.status==3||headerData.status==4)||statusView=='OC'&&(headerData.status==2||headerData.status==3||headerData.status==4)&&scope.$index!=ruleForm.tableData.length-1&&scope.$index!=ruleForm.tableData.length-2">
                      <el-input class="stretchNone" :disabled="scope.row.parentId?false:true" type="textarea" maxlength="1000" :autosize="{ minRows: 4, maxRows: 4}" :rows="4" placeholder="" v-model="scope.row.currentFinalFacts" style="width:100%;margin-top:15px;">
                      </el-input>
                      <i v-if="scope.row.parentId?true:false" @click.stop="openDialog(scope.row,scope.$index,'final')" style="position:absolute;right:10px;bottom:10%" class="el-icon-edit-outline"></i>
                    </div>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.currentFinalFacts" placement="top-start">
                      <span style="width:100%;display: inline-block;maxHeight: 130px;padding:20px 0px;box-sizing: border-box;">{{scope.row.currentFinalFacts}}</span>
                    </el-tooltip>
                  </div>
                  <el-tooltip v-else class="item" effect="dark" :content="scope.row.currentFinalFacts" placement="top-start">
                    <span style="width:100%;display: inline-block;maxHeight: 130px;padding:20px 0px;box-sizing: border-box;">{{scope.row.currentFinalFacts}}</span>
                  </el-tooltip>
                </div>
                <el-tooltip v-else class="item" effect="dark" :content="scope.row.currentFinalFacts" placement="top-start">
                  <span style="width:100%;display: inline-block;maxHeight: 130px;padding:20px 0px;box-sizing: border-box;">{{scope.row.currentFinalFacts}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>

        <el-table-column align="center" :label="lastAppraisePeriod" type="index">
          <el-table-column label="供应商自评" align="center">
            <el-table-column prop="lastSupplierScore" label="Score" align="center" width="80"></el-table-column>
            <el-table-column prop="lastSupplierWtScore" label="Wt. Score" align="center" width="80"></el-table-column>
            <el-table-column prop="lastSupplierFacts" label="Facts" align="center" width="300">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.lastSupplierFacts" placement="top-start">
                  <span style="width:100%;display: inline-block;maxHeight: 130px;padding:20px 0px;box-sizing: border-box;">{{scope.row.lastSupplierFacts}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Final" align="center" v-if="statusView=='C'||statusView=='O'||statusView=='OC'||statusView=='S'&&(headerData.status==5||headerData.status==6||headerData.status==7)">
            <el-table-column v-if="statusView=='C'||statusView=='O'||statusView=='OC'||statusView=='S'&&(headerData.status==5||headerData.status==6||headerData.status==7)" prop="lastFinalScore" label="Score" align="center" width="80"></el-table-column>
            <el-table-column v-if="statusView=='C'||statusView=='O'||statusView=='OC'||statusView=='S'&&(headerData.status==5||headerData.status==6||headerData.status==7)" prop="lastFinalWtScore" label="Wt. Score" align="center" width="80"></el-table-column>
            <el-table-column v-if="statusView!='S'" prop="lastFinalFacts" label="Facts" align="center" width="300">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.lastFinalFacts" placement="top-start">
                  <span style="width:100%;display: inline-block;maxHeight: 130px;padding:20px 0px;box-sizing: border-box;">{{scope.row.lastFinalFacts}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>

      </el-table>

      <!-- <el-row  style="margin-top:15px;height:100px;">
        <el-col :span="3" style="height:100%;display: flex;justify-content: center;align-items: center;">
            score Rating
        </el-col>
        <el-col :span="24" style="height:100%;">
          
            <table class="table-d">
                <tr>
                    <td>Score</td>
                    <td>{{getNumData.lastSupplierScore}}</td>
                    <td>{{getNumData.lastFinalScore}}</td>
                    <td>{{getNumData.supplierScore}}</td>
                    <td>{{getNumData.finalScore}}</td>
                </tr>
                <tr>
                    <td>Rating</td>
                    <td>{{getNumData.lastSupplierRating}}</td>
                    <td>{{getNumData.lastFinalRating}}</td>
                    <td>{{getNumData.supplierRating}}</td>
                    <td>{{getNumData.finalRating}}</td>
                </tr>
            </table>
        </el-col>
      </el-row> -->

      <el-row style="margin-top:10px;height:50px;">
        <el-col :span="3" style="height:100%;display: flex;justify-content: center;align-items: center;color:#EBB563;background:#FCFCFC;">
          供应商附件
        </el-col>
        <el-col :span="12" style="height:100%;display: flex;align-items: center;">
          <div v-if="isCanAudit">
            <el-button v-if="headerData.status==1&&statusView=='S'||(headerData.status==2||headerData.status==3)&&statusView=='C'||statusView=='O'&& (headerData.status==3||headerData.status==4)||statusView=='OC'&&(headerData.status==2||headerData.status==3||headerData.status==4)||headerData.status==4&&(statusView=='O'||statusView=='OC')" size="small" type="primary" @click="openFile">
              {{$t('common.selectFile')}}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-table class="fileTable" ref="plxTable" :data="ruleForm.fileTable" @selection-change="selectionChange" max-height="500" show-overflow="ellipsis" highlight-current-row>
        <el-table-column align="center" label="附件名称" prop="documentName">
          <template slot-scope="scope">
            <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="附件描述" align="center" prop="docComments">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.docComments" placement="top-start">
              <span style="display: inline-block;maxHeight: 80px;padding:10px 0px;box-sizing: border-box;">{{scope.row.docComments}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="上传人" align="center" prop="userName"></el-table-column>
        <el-table-column label="上传时间" align="center" prop="createDate"></el-table-column>
        <el-table-column label="" align="center" prop="updateDate" v-if="headerData.status==1&&statusView=='S'||(headerData.status==2||headerData.status==3)&&statusView=='C'||statusView=='O'&& (headerData.status==2||headerData.status==3||headerData.status==4)||statusView=='OC'&&(headerData.status==2||headerData.status==3||headerData.status==4)||headerData.status==4&&(statusView=='O'||statusView=='OC')">
          <template v-slot="scope">
            <i class="el-icon-delete" style="color: red;" @click="delFile(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <uploadFile v-if="dialogVisible" @close="handleClose" :headerData="headerData" :tsReckindId="tsReckindId"></uploadFile>
    </el-dialog>

    <el-dialog title="" :visible.sync="addDialog" width="60%" :before-close="closeFactsDialog">
      <div slot="title" class="header-title">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">Facts填写</p>
        </div>
      </div>
      <factsDialog v-if="addDialog" @closeFacts="closeAddDialog" :factsInfo="factsInfo" :factsType="factsType"></factsDialog>
    </el-dialog>

  </div>
</template>

<script>
import ratingTask from "@/api/AAA/ratingTask.js";
import { fileService } from "@/api/common/file-utils"
import uploadFile from '@/components/page/QSPI/AAA/dialog/uploadFile'
import factsDialog from '@/components/page/QSPI/AAA/dialog/factsDialog'


export default {
  data() {
    return {
      factsIndex: "",
      factsType: "",
      factsInfo: {},
      addDialog: false,
      tsReckindId: "",
      userID: localStorage.getItem("ms_userId"),
      url: "",
      dialogVisible: false,
      ruleForm: {
        tableData: [{}],
        fileTable: [],
      },
      getNumData: {},
      headerData: {},
      lastAppraisePeriod: "",
      currentAppraisePeriod: "",
      temName: "",
      identity: localStorage.getItem('ms_emplFlag'),
      isShow: '',
      statusView: "",
      isCanAudit: "",
      rules: {
        currentSupplierScore: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        currentSupplierFacts: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        docComments: [
          { required: true, message: '请输入文件描述', trigger: 'blur' }
        ],
        currentFinalScore: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      rulesList: localStorage.getItem('ms_roles'),
      isRouter: sessionStorage.getItem('isRouter'),
      isBool: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(from)
    if (from.path == '/qspiAAATask') {
      sessionStorage.setItem('isRouter', 'grade')
      sessionStorage.setItem('isFromSummary', false)
    } else if (from.path == '/qspiAAASummary') {
      sessionStorage.setItem('isRouter', 'gather')
      sessionStorage.setItem('isFromSummary', true)
    } else if (from.path == '/qspiTodo') {
      sessionStorage.setItem('isRouter', 'qspiToDo')
      sessionStorage.setItem('isFromSummary', false)
    }
    next()
  },
  async created() {
    this.isCanAudit = JSON.parse(sessionStorage.getItem('taskDetail')).isCanAudit
    console.log("是否可以操作====", this.isCanAudit)
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));

    try {
      // 等待getDetail执行成功
      await this.getDetail()
      // 成功后执行getDetailData
      this.getDetailData()
    } catch (err) {
      this.$message.error('初始化数据失败：' + (err.msg || '网络异常'))
      console.error(err)
    }

    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
      this.isShow = false
    } else {
      if (this.rulesList.indexOf('QSPI_AAA_CQS') != -1 && this.rulesList.indexOf('QSPI_AAA_OWNER') != -1) {
        this.statusView = 'OC';
      } else {
        for (let i = 0, len = permission.length; i < len; i++) {
          if (permission[i] == 'QSPI_AAA_OWNER') {
            this.statusView = 'O';
            break
          } else {
            this.statusView = 'C';
          }
        }
      }
      this.isShow = true
    }
    console.log("11111111111", this.statusView)
    // else if(this.identity=='MCD'){
    //   this.statusView = 'C';
    //   this.isShow=true
    // }
  },
  components: { uploadFile, factsDialog },

  computed: {},

  methods: {
    handleClose() {
      this.dialogVisible = false
      this.getFileList()
    },
    openFile() {
      this.tsReckindId = 'SUPPLIER_SCORE'
      this.dialogVisible = true
    },
    openDialog(row, index, value) {
      this.factsType = value
      this.factsInfo = row
      this.factsIndex = index
      this.addDialog = true
    },
    closeFactsDialog() {
      this.addDialog = false
    },
    closeAddDialog(val) {
      console.log("sssssss", val)
      console.log('sssssss', this.factsType)
      if (val) {
        if (this.factsType == 'supplier') {
          this.ruleForm.tableData[this.factsIndex].currentSupplierFacts = val
        } else if (this.factsType == 'final') {
          this.ruleForm.tableData[this.factsIndex].currentFinalFacts = val
        }
      }
      this.addDialog = false
    },
    getDetail() {
      ratingTask.appraiseDetail(this.$route.query.id).then((res) => {
        this.headerData = res.data
        if ((this.headerData.status == 3) && this.statusView == 'OC' && this.isRouter == 'gather') {
          this.isBool = 'gather'
        } else if ((this.headerData.status == 3) && this.statusView == 'OC' && this.isRouter == 'grade') {
          this.isBool = 'grade'
        } else if (this.headerData.status == 2 && this.statusView == 'OC' && this.isRouter == 'grade') {
          this.isBool = 'All'
        } else if ((this.headerData.status == 4) && this.statusView == 'OC' && this.isRouter == 'grade') {
          this.isBool = 'gather'
        } else if ((this.headerData.status == 4) && this.statusView == 'OC' && this.isRouter == 'gather') {
          this.isBool = 'gather'
        }
        this.getFileList()
      })
    },
    saveData() {
      // this.$refs['ruleForm'].validate((valid) => {
      //   if (valid) {
      let arr = []
      let newArr = this.ruleForm.tableData.filter((a) => {
        return a.parentId
      })
      console.log("🚀 ~ file: markSheet.vue ~ line 431 ~ newArr ~ newArr", newArr)
      newArr.forEach((v, i) => {
        let obj = {}
        obj.facts = this.statusView == 'S' ? v.currentSupplierFacts : v.currentFinalFacts
        obj.score = this.statusView == 'S' ? v.currentSupplierScore : v.currentFinalScore
        obj.wtScore = this.statusView == 'S' ? Number(v.currentSupplierWtScore) : Number(v.currentFinalWtScore)
        obj.ttQspiAaaScoreDetailId = v.ttQspiAaaScoreDetailId
        arr.push(obj)
      })
      let params = {
        scoreBody: arr,
        isFromSummary: sessionStorage.getItem('isFromSummary')
      }
      ratingTask.saveFinalScore(params, this.headerData.ttQspiAaaScoreId).then((res) => {
        if (res.code == 200) {
          this.$message.success('保存成功')
          this.getDetailData()
        } else {
          this.$message.error(res.msg)
        }
      })
      // } else {
      //   console.log('error submit!!');
      //   return false;
      // }
      // });

    },
    tableRowClassName({ row, rowIndex }) {
      if (!row.parentId) {
        return 'dbGray_class';
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.isShow) {    //判断全部看到的情况
        if (this.statusView != 'S') {
          if (rowIndex == this.ruleForm.tableData.length - 1) {
            if (columnIndex === 8 || columnIndex === 9 || columnIndex === 10 || columnIndex === 11) {
              return [1, 3]//所以return[1,3], 占一行，占3列
            } else if (columnIndex === 11) {
              return [1, 2]//所以return[1,3], 占一行，占2列
            }
          }
          if (rowIndex == this.ruleForm.tableData.length - 2) {
            if (columnIndex === 8 || columnIndex === 9 || columnIndex === 10 || columnIndex === 11) {
              return [1, 3]
            } else if (columnIndex === 11) {
              return [1, 2]
            }
          }
        } else {
          if (this.headerData.status == 5 || this.headerData.status == 6 || this.headerData.status == 7) {     //判断是否可以看到cqs的分数
            if (rowIndex == this.ruleForm.tableData.length - 1) {
              if (columnIndex === 8 || columnIndex === 10) {
                return [1, 3]
              } else if (columnIndex === 9 || columnIndex === 11) {
                return [1, 2]
              }
            }
            if (rowIndex == this.ruleForm.tableData.length - 2) {
              if (columnIndex === 8 || columnIndex === 10) {
                return [1, 3]
              } else if (columnIndex === 9 || columnIndex === 11) {
                return [1, 2]
              }
            }
          } else {
            if (rowIndex == this.ruleForm.tableData.length - 1) {
              if (columnIndex === 8 || columnIndex === 9) {
                return [1, 3]
              } else if (columnIndex === 11 || columnIndex === 10) {
                return [1, 2]
              }
            }
            if (rowIndex == this.ruleForm.tableData.length - 2) {
              if (columnIndex === 8 || columnIndex === 9) {
                return [1, 3]
              } else if (columnIndex === 11 || columnIndex === 10) {
                return [1, 2]
              }
            }
          }
        }

      } else {
        if (this.statusView != 'S') {
          if (rowIndex == this.ruleForm.tableData.length - 1) {
            if (columnIndex === 3 || columnIndex === 4 || columnIndex === 6 || columnIndex === 5) {
              return [1, 3]
            }
          }
          if (rowIndex == this.ruleForm.tableData.length - 2) {
            if (columnIndex === 3 || columnIndex === 4 || columnIndex === 6 || columnIndex === 5) {
              return [1, 3]
            }
          }
        } else {
          if (this.headerData.status == 5 || this.headerData.status == 6 || this.headerData.status == 7) {  //可以看到cqs的分数
            if (rowIndex == this.ruleForm.tableData.length - 1) {
              if (columnIndex === 3 || columnIndex === 5) {
                return [1, 3]
              } else if (columnIndex === 4 || columnIndex === 6) {
                return [1, 2]
              }
            }
            if (rowIndex == this.ruleForm.tableData.length - 2) {
              if (columnIndex === 3 || columnIndex === 5) {
                return [1, 3]
              } else if (columnIndex === 4 || columnIndex === 6) {
                return [1, 2]
              }
            }
          } else {
            if (rowIndex == this.ruleForm.tableData.length - 1) {
              if (columnIndex === 3 || columnIndex === 4) {
                return [1, 3]
              } else if (columnIndex === 5 || columnIndex === 6) {
                return [1, 2]
              }
            }
            if (rowIndex == this.ruleForm.tableData.length - 2) {
              if (columnIndex === 3 || columnIndex === 4) {
                return [1, 3]
              } else if (columnIndex === 5 || columnIndex === 6) {
                return [1, 2]
              }
            }
          }

        }

      }

    },
    setHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (this.isShow) {    //判断可以全部看到
        if (rowIndex === 0) {
          row[0].rowSpan = 2
        }
        if (rowIndex === 1) {
          row[0].rowSpan = 0
        }
      } else {
        if (rowIndex === 0) {
          row[0].rowSpan = 2
          // document.getElementsByClassName('el-table_1_column_1')[0].setAttribute('rowspan',2)
          // console.log("看不到的row===",document.getElementsByClassName('el-table_1_column_1')[0])
        }
        if (rowIndex === 1) {
          row[0].rowSpan = 0
        }
      }
      // this.$refs.table.doLayout()
    },
    submitData() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let arr = []
          let newArr = this.ruleForm.tableData.filter((a) => {
            return a.parentId
          })
          newArr.forEach((v, i) => {
            let obj = {}
            obj.facts = this.statusView == 'S' ? v.currentSupplierFacts : v.currentFinalFacts
            obj.score = this.statusView == 'S' ? v.currentSupplierScore : v.currentFinalScore
            obj.wtScore = this.statusView == 'S' ? Number(v.currentSupplierWtScore) : Number(v.currentFinalWtScore)
            obj.ttQspiAaaScoreDetailId = v.ttQspiAaaScoreDetailId
            arr.push(obj)
          })
          let params = {
            scoreBody: arr,
            isFromSummary: sessionStorage.getItem('isFromSummary')
          }
          this.$confirm('是否确认提交?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            ratingTask.saveFinalScore(params, this.headerData.ttQspiAaaScoreId).then((res) => {
              if (res.code == 200) {
                ratingTask.submitFinalScore(this.headerData.ttQspiAaaScoreId).then((res) => {
                  if (res.code == 200) {
                    this.$message.success('提交成功')
                    this.getDetailData()
                    this.$router.go(-1)
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消提交'
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.headerData.ttQspiAaaScoreId;
        attachment.tsReckindId = 'SUPPLIER_SCORE';
        fileService.saveFile(attachment).then((saveRes) => {
          if (saveRes.code == 200) {
            this.$message.success('保存成功')
            this.getFileList()
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    onDownload(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    getDetailData() {
      ratingTask.getConditionList(this.$route.query.id, {}).then((res) => {
        console.log('getDetailData~res :', res);
        console.log('getDetailData~this.statusView :', this.statusView);
        console.log('getDetailData~this.headerData.status :', this.headerData.status);
        // 待供应商评分 1
        // 待CQS评分 2
        // CQS已提交 3
        // 已发布 4
        if (this.statusView == 'C' && (this.headerData.status == 2 || this.headerData.status == 3)
          || this.statusView == 'O' && (this.headerData.status == 3 || this.headerData.status == 4)
          || this.statusView == 'OC' && (this.headerData.status == 2 || this.headerData.status == 3 || this.headerData.status == 4)) {
          let flag = res.resultData.bodyList.every(ele => {
            return ele.currentFinalScore === null || ele.currentFinalScore === '' || ele.currentFinalScore === undefined || ele.currentFinalScore === NaN
          })
          console.log('flag :', flag);

          res.resultData.bodyList.forEach((v) => {
            if (flag) {
              if (v.currentFinalScore === null || v.currentFinalScore === '' || v.currentFinalScore === undefined || v.currentFinalScore === NaN) {
                v.currentFinalScore = v.lastFinalScore
              }
            }
            if (v.parentId === null || v.parentId === '' || v.parentId === undefined || v.parentId === NaN) {
              v.currentSupplierScore = null
              v.currentSupplierWtScore = null
              v.currentSupplierFacts = null
              v.currentFinalScore = null
              v.currentFinalWtScore = null
              v.currentFinalFacts = null
              v.lastSupplierScore = null
              v.lastSupplierWtScore = null
              v.lastSupplierFacts = null
              v.lastFinalScore = null
              v.lastFinalWtScore = null
              v.lastFinalFacts = null
            } else {
              v.currentFinalWtScore = Math.floor(100 * v.currentFinalScore * v.wt1 * 10) / 100
            }
          })
        }
        this.lastAppraisePeriod = res.resultData.bodyList[0].lastAppraisePeriod
        this.currentAppraisePeriod = res.resultData.bodyList[0].currentAppraisePeriod
        this.temName = 'AAA  ' + res.resultData.bodyList[0].version
        this.ruleForm.tableData = res.resultData.bodyList
        this.getNumData = res.resultData.headerData

        let setNewScore = ""
        let setNewRating = ""
        if (this.statusView == 'S') {
          if (this.headerData.status == 5 || this.headerData.status == 6 || this.headerData.status == 7) {
            setNewScore = res.resultData.headerData.finalScore
            setNewRating = res.resultData.headerData.finalRating
          } else {
            setNewScore = res.resultData.headerData.lastSupplierScore
            setNewRating = res.resultData.headerData.lastSupplierRating
          }
        } else {
          setNewScore = res.resultData.headerData.finalScore
          setNewRating = res.resultData.headerData.finalRating
        }
        // 最后两行数据汇总信息
        let scoreObj = {
          wt1View: "Score",
          currentSupplierScore: res.resultData.headerData.supplierScore,
          currentSupplierWtScore: setNewScore,
          currentSupplierFacts: res.resultData.headerData.lastSupplierScore,
          currentFinalScore: res.resultData.headerData.lastFinalScore
        }
        let ratingObj = {
          wt1View: "Rating",
          currentSupplierScore: res.resultData.headerData.supplierRating,
          currentSupplierWtScore: setNewRating,
          currentSupplierFacts: res.resultData.headerData.lastSupplierRating,
          currentFinalScore: res.resultData.headerData.lastFinalRating
        }
        this.ruleForm.tableData.push(scoreObj)
        this.ruleForm.tableData.push(ratingObj)
        console.log("详情列表数据=====", this.ruleForm.tableData)
      })
    },
    delFile(row) {
      if (row.createBy != this.userID) {
        this.$message.error('只能上传人操作附件')
      } else {
        fileService.deleteFile(row.tmDocumentId).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.getFileList()
          } else {
            this.$message.error(res.msg)
          }
        });
      }
    },
    cell({ row, colum, rowIndex, columnIndex }) {
      if (columnIndex == 16) {
        return 'setScore'
      }
    },
    routerBack() {
      this.$router.back();
    },
    changeShow() {
      this.isShow = !this.isShow
      this.$refs.table.doLayout()
      // this.$set(this.ruleForm.tableData)
      // this.$nextTick(()=>{
      //   this.$refs.table.doLayout()
      // })
      this.$forceUpdate()
    },
    getFileList() {
      let attachment = {};
      attachment.tsReckindId = "SUPPLIER_SCORE";
      attachment.tsRecId = this.headerData.ttQspiAaaScoreId;
      fileService.getFileList(attachment).then(res => {
        this.ruleForm.fileTable = res;
      });
    },
    setCurrent(row) {
      if (row.currentFinalScore > row.maxValue) {
        this.$message.error('输入的数值不能超过最大分数,请重新输入')
        return
      }
      row.currentFinalWtScore = Math.floor(100 * row.currentFinalScore * row.wt1 * 10) / 100
      // row.currentFinalWtScore=(row.currentFinalScore*row.wt1*10).toFixed(2);
    },
    setSup(row) {
      console.log('row :', row);
      if (row.currentSupplierScore > row.maxValue) {
        this.$message.error('输入的数值不能超过最大分数,请重新输入')
        return
      }
      row.currentSupplierWtScore = Math.floor(100 * row.currentSupplierScore * row.wt1 * 10) / 100
      // row.currentSupplierWtScore=(row.currentSupplierScore*row.wt1*10).toFixed(2);
    }
  }
}

</script>
<style  scoped>
/* .el-table td.is-hidden > *,.el-table th.is-hidden > * {
  visibility: visible;
} */
/deep/ .setTop .el-form-item {
  margin-top: 15px !important;
}
/* /deep/ .el-form-item {
  margin-top: 15px !important;
} */
/* /deep/ .el-table__row .cell{
  margin-top: 15px !important;
} */
/deep/ .el-form-item--small .el-form-item__error {
  font-size: 10px !important;
}

.stretchNone {
  margin-top: 18px !important;
}
/deep/ .stretchNone .el-textarea__inner {
  position: relative;
  resize: none;
}
/deep/ .stretchNone .el-textarea__inner::-webkit-scrollbar {
  display: none !important;
}
/deep/ .el-icon-edit-outline:before {
  font-size: 16px !important;
}
.setTable /deep/ .el-input--small .el-input__inner {
  height: 28px;
  line-height: 28px;
}
/deep/ .fileTable .el-table__row td .cell {
  max-height: 50px;
}
/deep/ .el-table__row td .cell {
  max-height: 130px;
}
/deep/ .el-table td.is-hidden > *,
.el-table th.is-hidden > * {
  visibility: visible;
}
/deep/ .el-table th > .cell {
  /* position: relative; */
  word-wrap: break-word;
  word-break: normal;
  text-overflow: auto;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
/deep/ .el-table__row td .cell {
  white-space: normal;
  word-wrap: break-word;
  word-break: normal;
}
/deep/ .elx-table .elx-body--column.col--ellipsis > .elx-cell {
  max-height: none;
}
.star {
  color: red;
}
</style>